export default __webpack_public_path__ + "static/media/sidebar-project_darkGray3.e5f8bdc1.svg";